<template>
    <div class="wl-container">
        <div :class="['table-container-wrapper', tableStatus.editable ? 'show-table-bottom-operate' : '']">
            <!--更新指导 start-->
            <div class="updateGuideTitle"  :style="{height: `${updateGuideTitleHeight}px`}" v-if="updateGuide && updateGuideStep === 1">
                <div class="updateGuideTip" :style="{top: `${updateGuideTitleHeight + 10}px`}">
                    <div class="margin-bottom-10">1/2</div>
                    <div class="margin-bottom-10">{{$t('filterFunction')}}</div>
                    <el-button @click="nextClick" class="guide-btn">{{ $t('next')}}</el-button>
                </div>
            </div>
            <!--更新指导 end-->
            <el-table
                border
                height="100%"
                :data="splitData"
                row-key="id"
                :tree-props="defaultProps"
                ref="finalTable"
                stripe
                :row-class-name="tableRowClassName"
                :header-cell-class-name="updateGuideClass"
                v-loading="loading"
                :default-expand-all="expand"
                @header-dragend="headerDrag"
                class="wl-table fixedFont"
                tcvf-table-name="pbc-f-table"
                :key="tableKey"
                :empty-text="$t('TABLE_NO_DATA')"
            >
                <!-- 选择列 -->
                <el-table-column fixed width="60">
                    <template slot="header" slot-scope="scope">
                        <div style="width: 100%; height: 100%; display: flex; align-items: center;justify-content: center;">
                            <i v-if="!expand" @click="expandAll" class="fa fa-angle-double-right openAll" aria-hidden="true"></i>
                            <i v-else @click="expandAll" class="fa fa-angle-double-down openAll" aria-hidden="true"></i>
                            <el-checkbox v-if="tableStatus.editable" @change="SelectionAll" :value="checkedAll"></el-checkbox>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox
                            v-if="tableStatus.editable && (!scope.row.childPbcGroup || !scope.row.childPbcGroup.length)"
                            :disabled="tableStatus.mode === 'setStatus' && scope.row.status !== '2' && scope.row.status !== '3'"
                            @change="handleSelectionChange(scope.row)"
                            :value="checkIsSelected(scope.row.id)"
                        ></el-checkbox>
                    </template>
                </el-table-column>

                <!-- 折叠列 -->
                <!-- <el-table-column class="fixedColumn" width="50" v-if="showColumns.includes('serialNo')">
                    <template #header>
                        <i
                            v-if="!expand && !tableStatus.editable"
                            @click="expandAll"
                            class="fa fa-angle-double-right openAll"
                            aria-hidden="true"
                        >
                        </i>
                        <i
                            v-if="expand && !tableStatus.editable"
                            @click="expandAll"
                            class="fa fa-angle-double-down openAll"
                            aria-hidden="true"
                        >
                        </i>
                    </template>
                    <template slot-scope="scope">
                        <span></span>
                    </template>
                </el-table-column> -->

                <!-- 实体 -->
                <el-table-column
                    prop="entityName"
                    width="200"
                    show-overflow-tooltip
                    :label="$t('TABLE_HEAD_EntityList')"
                    v-if="showColumns.includes('entityName')"
                >
                    <template slot="header" slot-scope="scope">
                        <div class="header-with-popup">
                            <span class="el-dropdown-link">
                                {{ $t('TABLE_HEAD_EntityList') }}
                                <i
                                    :class="['el-icon-arrow-down','table-header-edit-cls','th-header-edit', entityIds && entityIds.length > 0 && !getEntityIdsSelectAllTag ? 'el-icon-arrow-down-active' : '']"
                                    :title="$t('Filter_per_Entity')"
                                    @click="openEntity"
                                ></i>
                            </span>
                        </div>
                    </template>
                </el-table-column>

                <!-- 序列号 -->
                <el-table-column
                    class="fixedColumn"
                    :width="serialNoColumnWidth"
                    v-if="showColumns.includes('serialNo')">

                    <template #header>
                        <div class="header-with-popup">
                            {{ $t('serialNo') }}
                            <el-popover
                                    placement="bottom"
                                    trigger="click"
                                    :visible-arrow="false"
                                    @hide="hidePopperSearch">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i :class="['el-icon-arrow-down', serialNoHere ? 'el-icon-arrow-down-active' : '']"></i>
                                    </div>
                                </template>

                                <template>
                                    <el-input
                                        class="input-with-select"
                                        v-model="serialNoHere"
                                        size="medium"
                                        :placeholder="$t('serialNoPlaceholder')"
                                        clearable
                                    ></el-input>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span v-show="scope.row.topicSrc !== 1 || scope.row.pid !== null">{{ scope.row.serialNo }}</span>
                    </template>
                </el-table-column>

                <!-- 会计科目 -->
                <el-table-column
                    prop="topicName"
                    class="fixedColumn"
                    width="200"
                    show-overflow-tooltip
                    :label="$t('TABLE_HEADER_topicName')"
                    v-if="showColumns.includes('topicName')"
                >
                    <template #header>
                        <div class="header-with-popup">
                            {{ $t('TABLE_HEADER_topicName') }}
                            <TopicMultiSelectPopver
                                :hidePopperSearch="hidePopperSearch"
                                :value.sync="topicHere"
                                labelKey="topicName"
                                valueKey="topicId"
                                :inputFilterKey="['topicName', 'topicId']"
                                :options="topicList"
                            ></TopicMultiSelectPopver>
                        </div>
                    </template>
                </el-table-column>
                <!-- 已识别的相关数据要素 -->
                <el-table-column
                    prop="topicDesc"
                    width="220"
                    show-overflow-tooltip
                    v-if="showColumns.includes('topicDesc')">
                    <template #header>
                        <div class="header-with-popup">
                            {{ $t('PAFE_PBC_LIST_DESC') }}
                            <MultiSelectPopver
                                :hidePopperSearch="hidePopperSearch"
                                :value.sync="topicDesHere"
                                labelKey="topicDesc"
                                valueKey="topicId"
                                :inputFilterKey="['topicDesc', 'topicId']"
                                :options="topicDesList"
                            ></MultiSelectPopver>
                        </div>
                    </template>
                </el-table-column>
                <!-- 状态 -->
                <el-table-column
                    prop="status"
                    width="160"
                    v-if="showColumns.includes('status')">
                    <template #header>
                        <div class="header-with-popup">
                            {{ $t('FORM_LABEL_PROGRESS_STATUS') }}
                            <MultiSelectPopver
                                :hidePopperSearch="hidePopperSearch"
                                :value.sync="statusHere"
                                labelKey="xlabel"
                                valueKey="value"
                                :inputFilterKey="['xlabel', 'value']"
                                :dayOverDue.sync="dayOverDueHere"
                                :daysUntilDue.sync="daysUntilDueHere"
                                :options="[
                                    {
                                    xlabel: $t('Overdue'),
                                    internationalStatus: 'Overdue',
                                    label: 'Overdue',
                                    value: '5',
                                    showDayOverDue: true,
                                    showDaysUntilDue: false,
                                },
                                {
                                    xlabel: $t('DaysUntilDue'),
                                    internationalStatus: 'DaysUntilDue',
                                    label: 'DaysUntilDue',
                                    value: '6',
                                    showDayOverDue: false,
                                    showDaysUntilDue: true,
                                },
                                ...filterStatusList.map(v => ({
                                    xlabel: $t(v.internationalStatus),
                                    showDayOverDue: false,
                                    showDaysUntilDue: false,
                                    ...v
                                }))]"
                            ></MultiSelectPopver>
                        </div>
                    </template>

                    <template slot-scope="scope" v-if="!isParentNode(scope.row)">
                        <div v-if="['1'].includes(scope.row.applyFlag)">————</div>
                        <div v-else>
                            <div v-if="isClientUser">
                                <div
                                    v-for="item in statusList"
                                    v-if="item.value == scope.row.status"
                                    :class="`status_background_${mappingStatus(scope.row)}`"
                                    :key="item.key"
                                >
                                    <span style="padding-left: 22px">
                                        {{ scope.row.status === '1' ? formatDueDayDes(scope.row.dueDayDesc) : $t(item.internationalStatus) }}
                                    </span>
                                    <el-popover
                                        popper-class="breakWord"
                                        v-if="scope.row.status == '3' && scope.row.comments && scope.row.comments.length > 0"
                                        placement="right"
                                        title=""
                                        width="200"
                                        trigger="click"
                                        :content="scope.row.comments"
                                    >
                                        <i slot="reference" class="fa fa-commenting comments" aria-hidden="true"></i>
                                    </el-popover>
                                </div>
                            </div>
                            <div v-else>
                                <el-select
                                    collapse-tags
                                    v-model="scope.row.status"
                                    :disabled="
                                        (scope.row.status !== '2' && scope.row.status !== '3') || applyFlagDisabled(scope.row.applyFlag)
                                    "
                                    :class="`wl-item status_background_${mappingStatus(scope.row)}`"
                                    @change="onChangeOne(scope.row)"
                                >
                                    <template v-for="item in statusList">
                                        <el-option
                                            :key="item.value"
                                            :label="
                                                item.value === '1' ? formatDueDayDes(scope.row.dueDayDesc) : $t(item.internationalStatus)
                                            "
                                            :disabled="item.value == '1'"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </template>
                                </el-select>
                                <el-popover
                                    popper-class="breakWord"
                                    v-if="scope.row.comments && scope.row.comments.length > 0"
                                    placement="right"
                                    title=""
                                    width="200"
                                    trigger="click"
                                    :content="scope.row.comments"
                                >
                                    <i slot="reference" class="fa fa-commenting comments" aria-hidden="true"></i>
                                </el-popover>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <!-- 创建日期 -->
                <el-table-column
                    prop="createDate"
                    :label-class-name="`table-header-editable ${isClientUser ? 'not-allow' : ''}`"
                    width="150"
                    v-if="showColumns.includes('createDate')">
                    <template slot="header">
                        <div class="header-with-popup">
                            {{ $t('create_date') }}
                            <DatePickerPopover
                                :value.sync="createDateHere"
                                :hidePopperSearch="hidePopperSearch"
                            ></DatePickerPopover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.createDate | formatDate }}</span>
                    </template>
                </el-table-column>

                <!-- 毕马威建议截止日期 -->
                <el-table-column
                    prop="dueDateStamp"
                    :label-class-name="`table-header-editable ${isClientUser ? 'not-allow' : ''}`"
                    width="210"
                    v-if="showColumns.includes('dueDateStamp')"
                >
                    <template slot="header" slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="$t('Due_Date_can_not_edit')" placement="top">
                            <span @click="showHeaderDueDayPicker">
                                <i
                                    ref="header-calendar-icon"
                                    v-if="getUser.userType === '1'"
                                    class="el-icon-date table-header-edit-cls"
                                    :title="$t('pbc_batch_upload_tip')"
                                />
                                <el-date-picker
                                    :disabled="isClientUser"
                                    :clearable="false"
                                    v-model="editDueDayPicker"
                                    ref="header-dueday-picker"
                                    style="visibility: hidden; position: absolute; top: 0; left: 0; z-index: -1"
                                    @change="dateBatchChange"
                                >
                                </el-date-picker>
                                {{ $t('KPMG_Due_Date') }}
                            </span>
                        </el-tooltip>
                        <DatePickerPopover
                            :value.sync="dueTimeHere"
                            :hidePopperSearch="hidePopperSearch"
                        ></DatePickerPopover>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="isClientUser && !isParentNode(scope.row)">{{ scope.row.dueDay | formatDate }}</span>
                        <el-date-picker
                            :clearable="false"
                            v-else-if="!isParentNode(scope.row)"
                            :disabled="
                                isClientUser ||
                                isAccepted(scope.row.status) ||
                                applyFlagDisabled(scope.row.applyFlag) ||
                                isUploaded(scope.row.status)
                            "
                            style="width: 100%"
                            v-model="scope.row.dueDay"
                            :picker-options="getOption(scope.row.periodEndDateStamp)"
                            @change="(val) => onDuedayChange(val, scope.row.id)"
                            type="date"
                        >
                        </el-date-picker>
                    </template>
                </el-table-column>

                <!-- authorised client and KPMG team members can edit it anytime until the item is "Accepted" -->
                <!-- 客户确认截止日期 -->
                <el-table-column
                    prop="confirmDayStamp"
                    label-class-name="table-header-editable"
                    width="240"
                    :label="$t('Client_Confirmed_Due_Date')"
                    v-if="showColumns.includes('confirmDayStamp')"
                >
                    <template slot="header" slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="$t('Due_Date_can_not_edit')" placement="top">
                            <span @click="showHeaderConfirmDayStampPicker">
                                <i
                                    ref="header-calendar-icon"
                                    class="el-icon-date table-header-edit-cls"
                                    :title="$t('pbc_batch_upload_tip')"
                                />
                                <el-date-picker
                                    :clearable="false"
                                    v-model="editConfirmDayPicker"
                                    ref="header-confirm-day-picker"
                                    style="visibility: hidden; position: absolute; top: 0; left: 0; z-index: -1"
                                    @change="dateBatchConfirmDayChange"
                                >
                                </el-date-picker>
                                {{ $t('Client_Confirmed_Due_Date') }}
                            </span>
                        </el-tooltip>
                        <DatePickerPopover
                            :value.sync="clientConfirmDateHere"
                            :hidePopperSearch="hidePopperSearch"
                        ></DatePickerPopover>
                    </template>
                    <template slot-scope="scope">
                        <el-date-picker
                            v-if="!isParentNode(scope.row)"
                            class="wl-item wl-date-item"
                            type="date"
                            :disabled="
                                isAccepted(scope.row.status) || isUploaded(scope.row.status) || applyFlagDisabled(scope.row.applyFlag)
                            "
                            :picker-options="getOption(scope.row.periodEndDateStamp)"
                            v-model="scope.row.confirmDayStamp"
                            @change="(val) => onConfirmDayChange(val, scope.row.id)"
                        ></el-date-picker>
                    </template>
                </el-table-column>
                <!-- 信息来源 -->
                <!-- source of information is input by KPMG user and share to client user as well. -->
                <el-table-column prop="sourceType" width="200" v-if="showColumns.includes('sourceType')">
                    <!-- 信息来源列，表头增加批量配置 -->
                    <template slot="header" slot-scope="scope">
                        <span style="display: flex; flex-direction: row; align-items: center;">
                            <el-dropdown trigger="click" @command="handlePatchSetSourceOfInformation" placement="bottom-start">
                                <span class="el-dropdown-link" :title="$t('PAGE_MATTERLOG_SOURCE_OF_INFORMATION')">
                                    <i class="el-icon-edit-outline table-header-edit-cls" :title="$t('pbc_batch_upload_tip')"></i>
                                    {{ $t('PAGE_MATTERLOG_SOURCE_OF_INFORMATION') }}
                                </span>
                                <el-dropdown-menu slot="dropdown" v-if="isClientUser">
                                    <!-- <el-dropdown-item :key="-2" :command="{ value: '-2' }">
                                        {{ $t('NOT_APPLICABLE_CLIENT') }}
                                    </el-dropdown-item> -->
                                </el-dropdown-menu>
                                <el-dropdown-menu slot="dropdown" v-else>
                                    <el-dropdown-item v-for="item in sourceTypes" :key="item.value" :command="item">
                                        {{ $t(item.internationalStatus) }}
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <MultiSelectPopver
                                :hidePopperSearch="hidePopperSearch"
                                :value.sync="sourceOfInfoHere"
                                labelKey="rlabel"
                                valueKey="value"
                                :inputFilterKey="['rlabel', 'value']"
                                :options="sourceTypes.map(v => ({rlabel: $t(v.internationalStatus), ...v}))"
                            ></MultiSelectPopver>
                        </span>
                    </template>
                    <template slot-scope="scope">
                        <template v-if="isClientUser && !isParentNode(scope.row)">
                            <el-tooltip
                                :disabled="!getSourceTypeKey(scope.row.sourceType)"
                                class="item"
                                effect="dark"
                                :content="getSourceTypeKey(scope.row.sourceType) && $t(getSourceTypeKey(scope.row.sourceType))"
                                placement="top-start"
                            >
                                <el-select
                                    :disabled="scope.row.status === '4' || scope.row.sourceType === '-2' || isClientUser"
                                    v-model="scope.row.sourceType"
                                    :title="getSourceTypeKey(scope.row.sourceType) && $t(getSourceTypeKey(scope.row.sourceType))"
                                    @change="changeSourceType(scope.row)"
                                    @visible-change="sourceTypeVisible($event, scope.row.sourceType)"
                                >
                                    <el-option
                                        v-if="scope.row.sourceType != null"
                                        :label="$t(getSourceTypeKey(scope.row.sourceType))"
                                        :value="scope.row.sourceType"
                                    />
                                    <!-- <el-option :label="$t('NOT_APPLICABLE_CLIENT')" value="-2" /> -->
                                </el-select>
                            </el-tooltip>
                        </template>
                        <template v-else-if="!isParentNode(scope.row)">
                            <!--                kpg-->
                            <el-tooltip
                                :disabled="!getSourceTypeKey(scope.row.sourceType)"
                                class="item"
                                effect="dark"
                                :content="getSourceTypeKey(scope.row.sourceType) && $t(getSourceTypeKey(scope.row.sourceType))"
                                placement="top-start"
                            >
                                <el-select
                                    :disabled="scope.row.status === '4'"
                                    v-model="scope.row.sourceType"
                                    :title="getSourceTypeKey(scope.row.sourceType) && $t(getSourceTypeKey(scope.row.sourceType))"
                                    @change="onChangeRow(scope.row, 'sourceType')"
                                >
                                    <el-option
                                        v-for="item in sourceTypes"
                                        :key="item.value"
                                        :label="$t(item.internationalStatus)"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-tooltip>
                        </template>
                    </template>
                </el-table-column>

                <!-- 是否适用 -->
                 <el-table-column prop="applyFlag" width="200" v-if="showColumns.includes('applyFlag')">
                    <!-- 是否适用列，表头增加批量配置 -->
                    <template slot="header" slot-scope="scope">
                        <span style="display: flex; flex-direction: row; align-items: center;">
                            <el-dropdown trigger="click" @command="handlePatchSetApplyFlag" placement="bottom-start">
                                <span class="el-dropdown-link" :title="$t('PAGE_MATTERLOG_APPLY_FLAG')">
                                    <i class="el-icon-edit-outline table-header-edit-cls" :title="$t('pbc_batch_upload_tip')"></i>
                                    {{ $t('PAGE_MATTERLOG_APPLY_FLAG') }}
                                </span>
                            
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item
                                        v-for="(item, index) in applyFlagsForView"
                                        :key="index"
                                        :command="item"
                                    >
                                        {{ $t(item.label) }}
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <MultiSelectPopver
                                :hidePopperSearch="hidePopperSearch"
                                :value.sync="applyFlagHere"
                                labelKey="rlabel"
                                valueKey="internationalStatus"
                                :inputFilterKey="['rlabel', 'internationalStatus']"
                                :options="applyFlags.map(v => ({rlabel: $t(v.label),...v}))"
                            ></MultiSelectPopver>
                        </span>
                    </template>
                    <template slot-scope="scope">
                        <template v-if="!isParentNode(scope.row)">
                            <!--                kpg-->
                            <el-tooltip
                                :disabled="!getApplyFlagKey(scope.row.applyFlag) || !getApplyFlagTooltip(scope.row)"
                                class="item"
                                effect="dark"
                                :content="getApplyFlagKey(scope.row.applyFlag) && getApplyFlagTooltip(scope.row)"
                                placement="top-start"
                            >
                                <el-select
                                    :disabled="scope.row.status === '4'"
                                    v-model="scope.row.applyFlag"
                                    :title="getApplyFlagKey(scope.row.applyFlag) && $t(getApplyFlagKey(scope.row.applyFlag))"
                                    @change="onChangeRow(scope.row, 'applyFlag')"
                                >
                                    <el-option
                                        v-for="(item, index) in applyFlagsForView"
                                        :key="index"
                                        :label="item.label"
                                        :value="item.internationalStatus"
                                    >
                                    </el-option>
                                </el-select>
                            </el-tooltip>
                        </template>
                    </template>
                </el-table-column>

                <!-- 客户方负责人 -->
                <el-table-column
                    prop="clientUserName"
                    :label-class-name="`table-header-editable ${isClientUser ? 'not-allow' : ''}`"
                    width="300"
                    v-if="showColumns.includes('clientUserName')">

                    <template slot="header" slot-scope="scope">
                        <span v-if="isClientUser" class="el-dropdown-link" :title="$t('PAGE_TABLE_HEADER_clientUserName')">
                            {{ $t('PAGE_TABLE_HEADER_clientUserName') }}
                        </span>
                        <el-popover v-else ref="clientPopover" trigger="click" placement="bottom-start">
                            <template #reference>
                                <span class="el-dropdown-link" :title="$t('PAGE_TABLE_HEADER_clientUserName')">
                                    <i class="el-icon-edit-outline table-header-edit-cls" :title="$t('pbc_batch_upload_tip')"></i>
                                    {{ $t('PAGE_TABLE_HEADER_clientUserName') }}
                                </span>
                            </template>
                            <div class="client-multiselect">
                                <el-input
                                    v-model="clientOwnerDropdownFilterInput"
                                    size="mini"
                                    :placeholder="$t('PAGE_TABLE_HEADER_clientUserName')"
                                    clearable
                                ></el-input>
                                <div class="select-btn-row">
                                    <span class="select-btn" @click="clientBatch({ userId: clientUserHere, userType: '2' })">{{ $t('btn_submit') }}</span>
                                </div>
                                <div>
                                    <el-tag
                                        class="select-tag"
                                        v-for="(tagItem, tagIndex) in clientUserHereTags"
                                        :key="tagIndex"
                                    >{{ tagItem.userName }}</el-tag>
                                </div>
                                <div class="group-check">
                                    <el-checkbox-group 
                                        v-model="clientUserHere"
                                        class="group-check-checkbox"
                                        :max="3">
                                        <el-checkbox
                                            v-for="(item, index) in clientOwnerDropdownList"
                                            :label="item.userId"
                                            :key="index"
                                        >
                                            {{ item.userName }}
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </div>
                        </el-popover>
                        <MultiSelectPopver
                            :hidePopperSearch="hidePopperSearch"
                            :value.sync="clientResponsibleHere"
                            labelKey="userName"
                            valueKey="userId"
                            :inputFilterKey="['userName', 'userId']"
                            :options="clientOwnerList"
                            :initPopperData="selectAllUser"
                        ></MultiSelectPopver>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="!isParentNode(scope.row) && scope.row.clientUserName">
                            {{ scope.row.clientUserName }}
                        </span>
                        <i
                            v-if="
                                getUser.userType === '1' &&
                                !isParentNode(scope.row) &&
                                !isAccepted(scope.row.status) &&
                                !applyFlagDisabled(scope.row.applyFlag)
                            "
                            class="el-icon-edit item-edit-cls"
                            @click="editInCharge(scope.row, 1)"
                        ></i>
                    </template>
                </el-table-column>
                <!-- 毕马威负责人 -->
                <el-table-column
                    prop="kpmgUserName"
                    width="250"
                    :label-class-name="`table-header-editable ${isClientUser ? 'not-allow' : ''}`"
                    v-if="showColumns.includes('kpmgUserName')"
                >
                    <template slot="header" slot-scope="scope">
                        <span v-if="isClientUser" class="el-dropdown-link" :title="$t('TABLE_HEADER_kpmgUserName')">
                            {{ $t('TABLE_HEADER_kpmgUserName') }}
                        </span>
                        <el-dropdown v-else trigger="click" @command="handleCommand" placement="bottom-start">
                            <span class="el-dropdown-link" :title="$t('TABLE_HEADER_kpmgUserName')">
                                <i class="el-icon-edit-outline table-header-edit-cls" :title="$t('pbc_batch_upload_tip')"></i>
                                {{ $t('TABLE_HEADER_kpmgUserName') }}
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-input
                                    v-model="kpmgOwnerDropdownFilterInput"
                                    size="mini"
                                    :placeholder="$t('TABLE_HEADER_kpmgUserName')"
                                    clearable
                                ></el-input>
                                <el-dropdown-item
                                    v-for="(item, index) in kpmgOwnerDropdownList"
                                    :key="index"
                                    :command="{ userId: item.id, userType: '1' }"
                                >
                                    {{ item.userName }} ({{ item.profitCenter }})
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <MultiSelectPopver
                            :hidePopperSearch="hidePopperSearch"
                            :value.sync="kpmgResponsibleHere"
                            labelKey="rlabel"
                            valueKey="id"
                            :inputFilterKey="['rlabel', 'id']"
                            :options="kpmgOwnerList.map(v => ({rlabel: v.userName+'('+v.profitCenter +')', ...v}))"
                            :initPopperData="selectAllUser"
                        ></MultiSelectPopver>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="!isParentNode(scope.row) && scope.row.kpmgUserName">{{ scope.row.kpmgUserName }}</span>
                        <i
                            v-if="
                                getUser.userType === '1' &&
                                !isParentNode(scope.row) &&
                                !isAccepted(scope.row.status) &&
                                !applyFlagDisabled(scope.row.applyFlag)
                            "
                            class="el-icon-edit item-edit-cls"
                            @click="editInCharge(scope.row, 0)"
                        ></i>
                    </template>
                </el-table-column>
                <!-- 最近上传人 -->
                <el-table-column
                    prop="uploadedBy"
                    width="150"
                    show-overflow-tooltip
                    :label="$t('TABLE_HEADER_uploadedBy')"
                    v-if="showColumns.includes('uploadedBy')">
                    <template slot="header" slot-scope="scope">
                        {{ $t('TABLE_HEADER_uploadedBy') }}                    
                        <MultiSelectPopver
                            :hidePopperSearch="hidePopperSearch"
                            :initPopperData="selectAllUser"
                            :value.sync="lastedUploadUserAccountHere"
                            labelKey="rlabel"
                            valueKey="userAccount"
                            :inputFilterKey="['rlabel', 'userAccount']"
                            :options="[
                                ...kpmgOwnerList.map(v => ({rlabel: v.userName+'('+v.profitCenter +')', ...v})),
                                ...clientOwnerList.map(v => {
                                    let obj = {}
                                    if(v.userName !== $t('common_empty')) {
                                       obj =  {rlabel: v.userName, ...v}
                                    }
                                    return obj
                                })
                            ]"
                        ></MultiSelectPopver>
                    </template>
                </el-table-column>
                <!-- 最近上传时间 -->
                <el-table-column
                    prop="uploadedDateStamp"
                    width="180"
                    v-if="showColumns.includes('uploadedDateStamp')">
                    <template #header>
                        <div class="header-with-popup">
                            {{ $t('TABLE_HEADER_uploadedDate') }}
                            <DatePickerPopover
                                :value.sync="uploadTimeHere"
                                :hidePopperSearch="hidePopperSearch"
                            ></DatePickerPopover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row.uploadedDateStamp | formatDateToSecond }}
                    </template>
                </el-table-column>
                <!-- 期末日期 -->
                <el-table-column
                    prop="periodEndDateStamp"
                    width="150"
                    v-if="showColumns.includes('periodEndDateStamp')">
                    <template #header>
                        <div class="header-with-popup">
                            {{ $t('TABLE_HEADER_periodEndDate') }}
                            <DatePickerPopover
                                :value.sync="periodEndDateHere"
                                :hidePopperSearch="hidePopperSearch"
                            ></DatePickerPopover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row.periodEndDateStamp | formatDate }}
                    </template>
                </el-table-column>
                <!-- 文件列表 -->
                <el-table-column
                    prop="fileNameList"
                    align="center"
                    fixed="right"
                    width="150"
                    v-if="showColumns.includes('fileNameList')">
                    <template #header>
                        <div class="header-with-popup">
                            {{ $t('TABLE_HEADER_fileNameList') }}
                            <el-popover
                                    placement="bottom"
                                    trigger="click"
                                    :visible-arrow="false"
                                    @hide="hidePopperSearch">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i :class="['el-icon-arrow-down', fileNameHere ? 'el-icon-arrow-down-active' : '']"></i>
                                    </div>
                                </template>

                                <template>
                                    <el-input
                                        class="input-with-select"
                                        v-model="fileNameHere"
                                        size="medium"
                                        :placeholder="$t('fileNameKeyword')"
                                        clearable
                                    ></el-input>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span class="file-number-hint" @click="showFileDetail(scope.row)" v-show="scope.row.fileNameList.length > 0">
                            {{ scope.row.fileNameList.length }}</span
                        >
                    </template>
                </el-table-column>
                <!-- 上传 -->
                <el-table-column width="70" align="center" :label="$t('COMMON_UPLOAD')" fixed="right" v-if="showColumns.includes('upload')">
                    <template slot-scope="scope">
                        <i
                            v-if="scope.row.childPbcGroup == null || scope.row.childPbcGroup.length <= 0"
                            :class="[
                                !hasPermission('upload') || applyFlagDisabled(scope.row.applyFlag) || isAccepted(scope.row.status)
                                    ? 'wl-icon-not-upload'
                                    : 'wl-icon-upload',
                                'el-icon-upload'
                            ]"
                            @click="openUpload(scope.row)"
                        ></i>
                    </template>
                </el-table-column>
                <!-- 留言 -->
                <el-table-column width="120" align="center" :label="$t('TABLE_HEAD_COMMENTS')" v-if="showColumns.includes('messageNum')" fixed="right">
                    <template #header>
                        <div class="header-with-popup">
                            {{ $t('TABLE_HEAD_COMMENTS') }}
                            <DatePickerPopover
                                :value.sync="commentDateHere"
                                :hidePopperSearch="hidePopperSearch"
                            ></DatePickerPopover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="flex  item-center justify-center" v-if="scope.row.childPbcGroup == null || scope.row.childPbcGroup.length <= 0">
                            <i
                                :class="[
                                    scope.row.todayCommentCount > 0 ? 'wl-icon-messageBoard' : 'wl-icon-messageBoardNull',
                                    'el-icon-s-comment'
                                ]"
                                @click="openMessageBoard(scope.row)"
                            ></i>
                            <span v-if="scope.row.todayCommentCount"> 
                                <span class="message-today">{{ scope.row.todayCommentCount }}</span>
                                <span>/</span> 
                            </span>
                            <span v-if="scope.row.messageNum > 0"> {{ scope.row.messageNum }}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="tableStatus.editable" class="wl-btn-container">
            <el-button class="cancel-btn" @click="deselectAll">{{ $t('comment_reSet') }} </el-button>

            <!-- 批量修改按钮 -->
            <el-button v-if="tableStatus.mode === 'setStatus'" :disabled="emptyChosen" @click="changeStatus" class="wl-green">
                {{ $t('COMMON_CHANGESTATUS') }}
            </el-button>

            <i v-if="downloading" title="downloading" class="el-icon-loading downloading-placeholder" />
            <!-- 下载按钮 -->
            <el-button
                v-else-if="tableStatus.mode === 'download'"
                :disabled="emptyChosen || downloading"
                @click="downLoad"
                class="wl-green"
            >
                <span>
                    <span>{{ $t('COMMON_DOWNLOAD') }}</span>
                    <span v-if="downloading">{{ $t('COMMON_ING') }}<span class="dotting"></span> </span>
                </span>
            </el-button>

            <el-button v-else-if="tableStatus.mode === 'export'" :disabled="emptyChosen || downloading" @click="downLoad" class="wl-green">
                <span>
                    <span>{{ $t('BATCH_export') }}</span>
                    <span v-if="downloading">{{ $t('COMMON_ING') }}<span class="dotting"></span> </span>
                </span>
            </el-button>

            <!-- 发送邮件按钮 -->
            <el-button v-if="tableStatus.mode === 'sendEmail'" :disabled="emptyChosen" @click="sendEmail" class="wl-green">
                {{ $t('PAGE_CLIENTUSER_EMAIL_PBC') }}
            </el-button>
        </div>

        <el-pagination
            :current-page="pagination.pageNum"
            class="wl-pagination"
            :page-size="pagination.pageSize"
            @current-change="onPageChange"
            layout="prev, pager, next, slot, total"
            :total="pagination.total"
        >
            <span>
                <el-select v-model="pagination.pageSize" @change="onSizeChange">
                    <el-option v-for="item in pageOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </span>
        </el-pagination>

        <upload v-if="addVisible" :saveLoading="btnLoading" :initData="initData" :onCancel="toggleAddVisible"/>
        <messageBoard v-if="messageBoardVisible" :initData="initData" :onCancel="toogleMessageBoardVisible" :onAdd="onUploadFileAfter" :messageType="messageType" :siteId="siteId">
        </messageBoard>

        <!--      文件详情-->
        <el-dialog
            :title="$t('TABLE_HEADER_fileNameList')"
            :visible.async="fileDetailVisbile"
            width="70%"
            top="10vh"
            :before-close="handleClose"
        >
            <div slot="title" class="title">
                <div class="detail-header">
                    <div class="title">
                        {{ $t('TABLE_HEADER_fileNameList') }}
                    </div>
                    <GuidanceTooltip
                        :size='24'
                        :content="$t('setFileAndDownloadTipHtml')"
                        :jumpLink="$t('setFileAndDownloadTipLink')"
                
                    ></GuidanceTooltip>
                </div>
            </div>
            <filelist-table
                slot
                :tableData="detailRow.fileNameList"
                :downloadAble="downloadAble"
                :curUserName="curUserName"
                :getPbcList="() => onUploadFileAfter()"
                @on-file-download="(rowParam) => downloadFile(rowParam, detailRow.id, detailRow)"
            />
        </el-dialog>
        <!--        修改负责人-->
        <el-dialog
            :title="isClientInCharge ? $t('TABLE_HEADER_clientUserName') : $t('TABLE_HEADER_kpmgUserName')"
            :visible.async="inChargeVisible"
            :close-on-click-modal="false"
            width="400px"
            @close="inChargeVisible = false"
        >
            <el-select v-if="isClientInCharge" v-model="clientInchargeListIds" style="width: 100%" clearable filterable multiple :multiple-limit="3">
                <el-option v-for="item in clientOwnerList" :key="item.userId" :label="item.userName" :value="item.userId"> </el-option>
            </el-select>
            <el-select v-else v-model="currentIncharge.kpmgInCharge" style="width: 100%" clearable filterable>
                <el-option
                    v-for="item in kpmgOwnerList"
                    :key="item.id"
                    :label="item.userName + ' ( ' + item.profitCenter + ' ) '"
                    :value="item.id"
                ></el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button class="wl-green" v-if="isClientInCharge" @click="onChargeUserChange(clientInchargeListIds, '2')">{{
                    $t('btn_submit')
                }}</el-button>
                <el-button class="wl-green" v-else @click="onChargeUserChange(currentIncharge.kpmgInCharge, '1')">{{
                    $t('btn_submit')
                }}</el-button>
            </span>
        </el-dialog>

        <!-- 批量发送邮件窗口 -->
        <el-dialog :title="$t('PAGE_CLIENTUSER_EMAIL_PBC')" :visible.sync="patchSendEmail.show" width="50%">
            <div>
                <el-form style="margin-bottom: 10px" label-width="200px" label-position="left">
                    <el-form-item :label="$t('recevier')">
                        <el-select v-model="patchSendEmail.choosed" multiple filterable clearable>
                            <el-option v-for="(v, k) in patchSendEmail.options" :key="k" :label="v.userName" :value="v.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('ccer')">
                        <el-select v-model="patchSendEmail.cc" multiple filterable clearable>
                            <el-option v-for="(v, k) in patchSendEmail.ccOptions" :key="k" :label="v.userName" :value="v.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="cancel-btn" @click="patchSendEmail.show = false" :loading="patchSendEmail.loading || loading">{{
                    $t('btn_cancel')
                }}</el-button>
                <el-button type="primary" class="cancel-btn" :loading="patchSendEmail.loading" @click="handlePatchSendEmail('myself')">{{
                    $t('send_me_a_preview')
                }}</el-button>
                <el-button class="wl-green" type="primary" @click="handlePatchSendEmail" :loading="patchSendEmail.loading || loading">{{
                    $t('comment_send')
                }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import CellItem from './table-cell-item'
    import {dateFormat, flatTopicList, isParentNode, pbcStatusEnum} from '@/utils'
    import Upload from './upload'
    import messageBoard from './messageBoard'
    import FilelistTable from './filelist-table'
    import {mapGetters} from 'vuex'
    import * as _ from 'lodash'
    import API from '@/api'
    import {userPermission} from '@/mixins/userPermission.js'
    import MultiSelectPopver from '@/components/common/MultiSelectPopver.vue'
    import TopicMultiSelectPopver from '@/components/common/TopicMultiSelectPopver.vue'
    import DatePickerPopover from '@/components/common/DatePickerPopover.vue'
    import GuidanceTooltip from '@/components/common/GuidanceTooltip.vue'

    export default {
    mixins: [userPermission],
    data() {
        return {
            pageOptions: [
                { label: '10/' + this.$t('page') + this.$t('page_tip'), value: 10 },
                { label: '50/' + this.$t('page'), value: 50 },
                { label: '100/' + this.$t('page'), value: 100 }
            ],
            editDueDayPicker: undefined,
            editConfirmDayPicker: undefined,
            noM: false,
            chosenList: [],
            defaultProps: {
                children: 'childPbcGroup',
                hasChildren: 'hasChildren'
            },
            tableKey: 'a',
            fileDetailVisbile: false,
            detailRow: {},
            addVisible: false,
            btnLoading: false,
            initData: '',
            expand: false,
            messageBoardVisible: false,
            clientInitSourceType: '',
            startIndex: 0,
            limitNum: Math.floor(document.body.clientHeight / 50),
            inChargeVisible: false,
            isClientInCharge: 0,
            clientInchargeListIds: [],
            currentIncharge: {
                clientInCharge: '',
                id: '',
                kpmgInCharge: ''
            },
            originStatus: '', // 临时记录单条记录状态修改前的值，方便取消修改时赋值
            patchSendEmail: {
                show: false,
                choosed: [],
                options: [],
                cc: [],
                ccOptions: [],
                loading: false,
                myself: false
            },
            clientOwnerDropdownFilterInput: '',
            kpmgOwnerDropdownFilterInput: '',
            filterChange: false,

            /**
             * 筛选条件从最顶部挪到了表头，就要在当前组件为每个筛选条件创建一个 data
             * data 变更的时候通过watch去更新父组件的值
             */
            serialNoHere: '',
            entityId: [],
            topicInputFilter: '',
            topicHere: [],
            topicDesHere: [],
            createDateHere: [],
            dueTimeHere: [],
            sourceOfInfoHere: [],
            applyFlagHere: [],
            statusHere: [],
            dayOverDueHere: [],
            daysUntilDueHere: [],
            uploadTimeHere: [],
            periodEndDateHere: [],
            commentDateHere: [],
            fileNameHere: '',
            clientUserHere: [],
            clientResponsibleHere: [],
            kpmgResponsibleHere: [],
            updateGuideTitleHeight: 0,
            lastedUploadUserAccountHere: [],
            clientConfirmDateHere: ['', '']
        }
    },
    mounted() {
        this.changeGuideTitleHeight()
    },
    filters: {
        formatDate: (value) => {
            if (value != null) {
                return dateFormat(new Date(value), 'yyyy-MM-dd')
            } else {
                return value
            }
        },
        formatDateToSecond: function (value) {
            if (value != null) {
                return dateFormat(new Date(value), 'yyyy-MM-dd hh:mm:ss')
            } else {
                return value
            }
        }
    },
    methods: {
        changeGuideTitleHeight() {
            setTimeout(() => {
                 
                this.updateGuideTitleHeight = document.getElementsByClassName('el-table__header-wrapper')[0].clientHeight
            }, 500)
        },
        resetNotStatus(allEntityIds){
            this.dayOverDueHere = []
            this.daysUntilDueHere = []
            this.topicHere = []
            this.topicDesHere = []
            this.uploadTimeHere = []
            this.dueTimeHere = []
            this.periodEndDateHere = []
            this.commentDateHere = []
            this.sourceOfInfoHere = []
            this.applyFlagHere = []
            this.$store.commit('common/setEntityIds', allEntityIds)
            this.kpmgResponsibleHere = []
            this.clientResponsibleHere = []
            this.createDateHere = []
            this.fileNameHere = ''
            this.serialNoHere = ''
            this.entityId = []
            this.lastedUploadUserAccountHere = []
            this.clientConfirmDateHere = []
            this.$nextTick(() => {
                this.filterChange = false
            })
        },
        cleanFilter(allEntityIds) {
            this.statusHere = []
            this.dayOverDueHere = []
            this.daysUntilDueHere = []
            this.topicHere = []
            this.topicDesHere = []
            this.uploadTimeHere = []
            this.dueTimeHere = []
            this.periodEndDateHere = []
            this.commentDateHere = []
            this.sourceOfInfoHere = []
            this.applyFlagHere = []
            this.$store.commit('common/setEntityIds', allEntityIds)
            this.kpmgResponsibleHere = []
            this.clientResponsibleHere = []
            this.createDateHere = []
            this.fileNameHere = ''
            this.serialNoHere = ''
            this.entityId = []
            this.lastedUploadUserAccountHere = []
            this.clientConfirmDateHere = []

            // this.submitted_before_deadline_pbc_request = false
            // this.overdued_pbc_count = false
            //  
            this.$nextTick(() => {
                this.hidePopperSearch(true)
            })
        },
         /**
         * 筛选条件里“序号”，blur的时候处理输入过滤
         * 只允许区间筛选（5-12）和单独的数字筛选（5），其余情况不触发搜索
         */
        hidePopperSearch(force = false) {
            if ((this.serialNoHere || '').split(',').some(v => {
                if (v.indexOf('-') !== -1) {
                    const serialNoArr = this.serialNoHere.split('-')
                    if (
                        serialNoArr.length !== 2 ||
                        serialNoArr.some(v => isNaN(v - 0)) ||
                        serialNoArr[1] - 0 < serialNoArr[0] - 0
                    ) {
                        return true
                    }
                } else if (isNaN(v - 0)) {
                    return true
                } else {
                    return false
                }
            })) {
                this.serialNoHere = ''
                this.$message.warning(this.$t('please_input_valid_serino'))
                return
            }

            if (this.filterChange || force) {
                this.filterChange = false
                this.onPaginationChange(1, this.pagination.pageSize)
            }
        },
        initStartIndex() {
            this.startIndex = 0
        },
        scrollFn(res, dom) {
            let clientHeight = res.target.clientHeight //可视区域高度
            let scrollTop = res.target.scrollTop //滚动高度
            let scrollHeight = res.target.scrollHeight // 可滚动高度
            if (scrollTop === 0 && this.startIndex > 0) {
                this.startIndex -= 1
                dom.scrollTop = scrollHeight - clientHeight - 10
            }
            if (
                clientHeight + scrollTop + 10 > scrollHeight &&
                (this.startIndex + 1) * this.limitNum + 2 < this.pagination.pageSize &&
                (this.startIndex + 1) * this.limitNum + 2 < this.data.length
            ) {
                this.startIndex += 1
                dom.scrollTop = 40
            }
        },
        scrollEvent(prevDom) {
            this.$nextTick(() => {
                let dom = this.$refs.finalTable.bodyWrapper
                prevDom.removeEventListener('scroll', (res) => this.scrollFn(res, prevDom), true)
                dom.addEventListener('scroll', (res) => this.scrollFn(res, dom), true)
            })
        },
        // 获取发送邮件的人的列表
        getEmailReciverOptions() {
            API.exchange.queryClientUserList({ siteId: this.siteId }).then((res) => {
                if (res.code == '1') {
                    this.patchSendEmail.options = res.data
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
            API.status.queryKPMemberBySite({ siteId: this.siteId, userType: '1' }).then((res) => {
                this.patchSendEmail.ccOptions = res.data
            })
        },
        // 批量发送邮件，确认发送
        handlePatchSendEmail(e) {
            if (e !== 'myself' && this.patchSendEmail.choosed.length == 0) {
                this.$message.error(this.$t('please_choose_recevier'))
                return
            }
            this.patchSendEmail.loading = true
            API.pbc
                .sendPbcFileNotificationEmail({
                    sendUserIdList: e == 'myself' ? ['myself'] : this.patchSendEmail.choosed,
                    siteId: this.siteId,
                    ccUserIdList: e == 'myself' ? [] : this.patchSendEmail.cc,
                    pbcGroupList: this.chosenList.map((_v) => {
                        const v = this.data
                            .reduce((pre, cur) => {
                                if (!pre) pre = []
                                if (cur.childPbcGroup && cur.childPbcGroup.length > 0) {
                                    pre.push(...cur.childPbcGroup)
                                } else {
                                    pre.push(cur)
                                }
                                return pre
                            }, [])
                            .find((__v) => __v.id == _v.id)
                        return {
                            parentName: (() => {
                                const findv = this.data.find((vv) => {
                                    if (vv.childPbcGroup && vv.childPbcGroup.length > 0) {
                                        return vv.childPbcGroup.some((vvv) => vvv.id == v.id)
                                    } else {
                                        return false
                                    }
                                })
                                return findv ? findv.topicName : ''
                            })(),
                            topicName: v.topicName,
                            topicDesc: v.topicDesc,
                            entityName: v.entityName,
                            periodEndDay: v.periodEndDay,
                            createDate: v.createDate,
                            dueDay: v.dueDay,
                            confirmDay: v.confirmDay,
                            clientUserName: v.clientUserName,
                            status: v.status,
                            topicSrc: v.topicSrc,
                            comments: v.comments,
                            clientAccount: v.clientAccount,
                            sourceType: v.sourceType,
                            serialNo: v.serialNo
                        }
                    })
                })
                .then((res) => {
                    if (res && res.code === '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.patchSendEmail.show = false
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
                .catch((e) => {
                    console.error(e)
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally(() => {
                    this.patchSendEmail.loading = false
                })
        },
        // 批量发送邮件
        sendEmail() {
            this.patchSendEmail = {
                show: true,
                choosed: [],
                options: [],
                loading: false,
                cc: [],
                ccOptions: [],
                myself: false
            }
            this.getEmailReciverOptions()
        },
        // 批量设置信息来源
        handlePatchSetSourceOfInformation(e) {
            API.pbc
                .updatePbcSourceType({
                    siteId: this.siteId,
                    sourceType: e.value,
                    bindIdList: this.data
                        .reduce((pre, cur) => {
                            if (!pre) pre = []
                            if (cur.childPbcGroup && cur.childPbcGroup.length > 0) {
                                pre.push(...cur.childPbcGroup)
                            } else {
                                pre.push(cur)
                            }
                            return pre
                        }, [])
                        .map((v) => v.id)
                })
                .then((res) => {
                    if (res && res.code === '1') {
                        this.$message.success(this.$t('msg_success'))
                        // 如果已经成功了，先把列表里的数据变了
                        this.data.forEach((v) => {
                            if (v.childPbcGroup && v.childPbcGroup.length > 0) {
                                v.childPbcGroup.forEach((vv) => {
                                    vv.sourceType = e.value
                                })
                            }
                        })
                        this.onUploadFileAfter() // 用这个来刷新列表内容
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
                .catch((e) => {
                    console.error(e)
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 批量设置是否适用
        handlePatchSetApplyFlag(e) {
            API.pbc
                .updatePbcApplyFlag({
                    siteId: this.siteId,
                    applyFlag: e.internationalStatus,
                    bindIdList: this.data
                        .reduce((pre, cur) => {
                            if (!pre) pre = []
                            if (cur.childPbcGroup && cur.childPbcGroup.length > 0) {
                                pre.push(...cur.childPbcGroup)
                            } else {
                                pre.push(cur)
                            }
                            return pre
                        }, [])
                        .map((v) => v.id)
                })
                .then((res) => {
                    if (res && res.code === '1') {
                        this.$message.success(this.$t('msg_success'))
                        // 如果已经成功了，先把列表里的数据变了
                        this.data.forEach((v) => {
                            if (v.childPbcGroup && v.childPbcGroup.length > 0) {
                                v.childPbcGroup.forEach((vv) => {
                                    vv.sourceType = e.value
                                })
                            }
                        })
                        this.onUploadFileAfter() // 用这个来刷新列表内容
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
                .catch((e) => {
                    console.error(e)
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally(() => {
                    this.loading = false
                })
        },
        applyFlagDisabled(applyFlag) {
            return applyFlag === '1'
        },
        sourceTypeShowIcon(sourceType) {
            return sourceType != '-3' && sourceType != '-2' && sourceType != null && sourceType != ''
        },
        changeSourceType(row) {
            this.$confirm(this.$t('CHANGE_SOURCETYPE_NO_APPLICATION_WARNING'), this.$t('COMMON_TIP'), {
                confirmButtonText: this.$t('btn_confirm'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'warning'
            })
                .then(() => {
                    row.sourceType = '-2'
                    this.onChangeRow(row, 'sourceType')
                })
                .catch(() => {
                    row.sourceType = this.clientInitSourceType
                    this.$message({
                        type: 'info',
                        message: this.$t('CANCLE_OPERATION')
                    })
                })
        },
        sourceTypeVisible(event, sourceType) {
            if (event) {
                this.clientInitSourceType = sourceType
            }
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.applyFlag === '1') {
                return 'row-cls client-row-cls'
            } else if (row.sourceType === '-3') {
                return 'row-cls kpmg-row-cls'
            }
            return 'row-cls'
        },
        updateGuideClass({row, column, rowIndex, columnIndex}) {
            //  
            if(this.updateGuide && this.updateGuideStep === 1) { // 不同分辨率对应不同展示(后续还需调整)
                if(this.screenWidth <= 1280) {
                    if([2,3,4].includes(columnIndex)) {return 'updateGuideHeaderTitle'}
                }else if(this.screenWidth <= 1540) {
                    if([2,3,4,5].includes(columnIndex)) {return 'updateGuideHeaderTitle'}
                }else if(this.screenWidth <= 1710) {
                    if([2,3,4,5,6].includes(columnIndex)) {return 'updateGuideHeaderTitle'}
                }else if(this.screenWidth <= 2048){
                    if([2,3,4,5,6,7].includes(columnIndex)) {return 'updateGuideHeaderTitle'}
                }else {
                    if([2,3,4,5,6,7,8,9].includes(columnIndex)) {return 'updateGuideHeaderTitle'}
                }
            }
            return ''
        },
        isParentNode,
        getSourceTypeKey(key) {
            return this.sourceTypesMap[key]
        },
        getApplyFlagKey(key) {
            return this.applyFlagsMap[key]
        },
        getApplyFlagTooltip(row) {
            const applyLabel = row.applyType === '0' ? this.$t('CLIENT_ACTION') : row.applyType === '1' ? this.$t('KPMG_ACTION') : ''
            const operateUserLabel = row.operateUser ? ` ${row.operateUser}` : ''
            const operateTimeLabel = row.operateTime ? ` ${dateFormat(new Date(row.operateTime), 'yyyy-MM-dd')}` : ''
            return `${applyLabel}${operateUserLabel}${operateTimeLabel}`
        },
        showHeaderDueDayPicker() {
            if (!this.isClientUser) {
                this.$nextTick(() => {
                    this.$refs['header-dueday-picker'].showPicker()
                })
            }
        },
        showHeaderConfirmDayStampPicker() {
            this.$refs['header-confirm-day-picker'].showPicker()
        },
        headerDrag() {
            this.$nextTick(() => {
                this.$refs.finalTable.doLayout()
            })
        },
        getOption(endTime) {
            return {
                // disabledDate: time => {
                //     return time.getTime() > endTime
                // }
            }
        },
        formatDueDayDes(des) {
            if (localStorage.getItem('lang') === 'zh') {
                let str = String(des)
                if (this.isOverDue(str)) {
                    return '已逾期' + str.replace(' days overdue', '天')
                }
                if (this.isUntilDue(str)) {
                    return str.replace('days until due', '') + '天后到期'
                }
            }
            return des
        },
        isUntilDue(desc) {
            return desc.includes('days until due')
        },
        isOverDue(desc) {
            return !!desc && desc.includes('days overdue')
        },
        mappingStatus(row) {
            if (row.status === '1' && this.isOverDue(row.dueDayDesc)) {
                return '_1'
            }
            return row.status
        },
        mappingColor(row) {
            if (row.status === '1') {
                return {
                    color: this.isOverDue(row.dueDayDesc) ? pbcStatusEnum['_1'] : pbcStatusEnum[row.status]
                }
            } else {
                return {
                    color: pbcStatusEnum[row.status]
                }
            }
        },
        checkIsSelected: function (id) {
            return this.chosenListIds.includes(id)
        },
        showFileDetail(row) {
            this.fileDetailVisbile = true
            this.detailRow = row
        },
        handleClose() {
            this.fileDetailVisbile = false
        },
        // 记录改变之前的值
        recordInfo(show, v) {
            if (show) {
                this.originStatus = v.status
            }
        },
        onChangeOne(v) {
            if (v.status == '3') {
                this.$prompt('', this.$t('PAGE_PBC_COMMENTS'), {
                    inputType: 'textarea',
                    inputValidator: (value) => {
                        if (value && value.length > 400) {
                            return false
                        } else {
                            return true
                        }
                    },
                    inputErrorMessage: this.$t('FORM_VALIDATE_COMMENTS_MAX'),
                    confirmButtonText: this.$t('btn_confirm'),
                    cancelButtonText: this.$t('btn_cancel')
                })
                    .then(({ value }) => {
                        this.onChange(v, value)
                    })
                    .catch(() => {
                        v.status = '2'
                    })
            } else if (v.status === '4') {
                // 调整为“已接受”后，该PBC条目将不可再更新
                this.$confirm(this.$t('PBC_ACCEPT_CONFIRM_MSG'), this.$t('COMMON_TIP'), {
                    confirmButtonText: this.$t('btn_confirm'),
                    cancelButtonText: this.$t('btn_cancel'),
                    type: 'warning'
                })
                    .then(() => {
                        this.onChange(v, '')
                    })
                    .catch(() => {
                        v.status = this.originStatus
                    })
            } else {
                this.onChange(v, '')
            }
        },
        expandAll() {
            this.expand = !this.expand
            this.data.forEach((i, n) => {
                if (i.childPbcGroup && i.childPbcGroup.length > 0) {
                    this.$refs.finalTable.toggleRowExpansion(i, this.expand)
                }
            })
        },
        deletePblist() {},
        openUpload(data) {
            if (!this.hasPermission('upload') || this.applyFlagDisabled(data.applyFlag) || this.isAccepted(data.status)) {
                return
            }
            this.initData = data
            this.addVisible = !this.addVisible
        },
        downloadFile(rowParam, id) {
            this.onDownLoad([{ id, fileNameList: [{ name: rowParam.name, fileId: rowParam.fileId, uploadBy: rowParam.uploadBy }] }])
        },
        toggleAddVisible() {
            this.onUploadFileAfter()
            this.addVisible = !this.addVisible
        },
        // 留言
        openMessageBoard(row) {
            this.initData = row
            this.toogleMessageBoardVisible()
        },
        toogleMessageBoardVisible() {
            this.messageBoardVisible = !this.messageBoardVisible
        },
        getChosenList(arr) {
            arr.forEach((i) => {
                if ((i.childPbcGroup == null || i.childPbcGroup.length <= 0) && i.checked) {
                    this.chosenList.push(i)
                }
                if (i.childPbcGroup && i.childPbcGroup.length > 0) {
                    this.getChosenList(i.childPbcGroup)
                }
            })
        },
        handleSelectionChange(row) {
            const idx = this.chosenListIds.indexOf(row.id)
            if (idx !== -1) {
                this.chosenList.splice(idx, 1)
            } else {
                this.chosenList.push(row)
            }
        },
        getAllChosenList(arr, res = []) {
            arr.forEach((i) => {
                if (i.childPbcGroup == null || i.childPbcGroup.length <= 0) {
                    i.checked = true
                    res.push(i)
                }
                if (i.childPbcGroup && i.childPbcGroup.length > 0) {
                    this.getAllChosenList(i.childPbcGroup, res)
                }
            })
            return res
        },
        getAllChosenList2(arr, res = []) {
            arr.forEach((i) => {
                if ((i.childPbcGroup == null || i.childPbcGroup.length <= 0) && (i.status == '2' || i.status == '3')) {
                    i.checked = true
                    res.push(i)
                }
                if (i.childPbcGroup && i.childPbcGroup.length > 0) {
                    this.getAllChosenList2(i.childPbcGroup, res)
                }
            })
            return res
        },
        SelectionAll() {
            if (!this.checkedAll) {
                if (this.tableStatus.mode === 'setStatus') {
                    this.chosenList = [...new Set([...this.chosenList, ...this.getAllChosenList2(this.data)])]
                } else {
                    this.chosenList = [...new Set([...this.chosenList, ...this.getAllChosenList(this.data)])]
                }
            } else {
                const chosenList = [...new Set(this.chosenList)]
                for (let i = 0; i < this.tableInnerIds.length; i++) {
                    const id = this.tableInnerIds[i]
                    const idx = chosenList.findIndex((item) => item.id === id)
                    if (idx !== -1) chosenList.splice(idx, 1)
                }
                this.chosenList = chosenList
            }
        },
        deselectAll() {
            this.chosenList = []
            const _update = function (data) {
                for (let i = 0; i < data.length; i++) {
                    data[i].checked = false
                    let hasChildren = _.isArray(data[i].childPbcGroup)
                    if (hasChildren && data[i].childPbcGroup.length > 0) {
                        _update(data[i].childPbcGroup)
                    }
                }
            }
            _update(this.data)
            this.onCancel()
        },
        changeStatus() {
            this.onChangeStatusPopShow(this.chosenList)
        },
        downLoad() {
            this.onDownLoad(this.chosenList)
        },
        onPageChange(pageNum) {
            this.$refs.finalTable.bodyWrapper.scrollTop = 0
            this.startIndex = 0
            this.expand = false
            this.onPaginationChange(pageNum, this.pagination.pageSize)
        },
        onSizeChange(size) {
            this.pagination.pageNum = 1
            this.onPaginationChange(1, size)
        },
        onDuedayChange(val, bindId) {
            this.$emit('on-dueday-change', { dueDayTime: dateFormat(val, 'yyyy-MM-dd'), bindIdList: [bindId] })
        },
        selectAllUser() {
            this.$emit('selectClientOwner')
            this.$emit('selectKPOwner')
        },
        dateBatchChange(val) {
            const result = []
            flatTopicList(this.data, result)
            this.$emit('on-dueday-change', {
                dueDayTime: dateFormat(val, 'yyyy-MM-dd'),
                bindIdList: result
                    .filter((item) => !isParentNode(item) && !this.isAccepted(item.status) && !this.isUploaded(item.status))
                    .map((item) => item.id)
            })
            this.editDueDayPicker = undefined
        },
        dateBatchConfirmDayChange(val) {
            const result = []
            flatTopicList(this.data, result)
            this.$emit('on-confirm-day-change', {
                confirmDayTime: dateFormat(val, 'yyyy-MM-dd'),
                bindIdList: result
                    .filter((item) => !isParentNode(item) && !this.isAccepted(item.status) && !this.isUploaded(item.status))
                    .map((item) => item.id)
            })
            this.editConfirmDayPicker = undefined
        },
        onConfirmDayChange(val, bindId) {
            const confirmDayTime = val && dateFormat(val, 'yyyy-MM-dd')
            this.$emit('on-confirm-day-change', { confirmDayTime, bindIdList: [bindId] })
        },
        clientBatch({ userId, userType }) {
            const result = []
            flatTopicList(this.data, result)
            this.$emit('on-charge-user-change', {
                userId: userId.join(','),
                bindIdList: result.filter((item) => !isParentNode(item) && !this.isAccepted(item.status)).map((item) => item.id),
                userType
            })
            this.$refs.clientPopover.doClose()
        },
        handleCommand({ userId, userType }) {
            const result = []
            flatTopicList(this.data, result)
            this.$emit('on-charge-user-change', {
                userId,
                bindIdList: result.filter((item) => !isParentNode(item) && !this.isAccepted(item.status)).map((item) => item.id),
                userType
            })
        },
        onChargeUserChange(userId, userType) {
            if (this.isClientInCharge) {
                this.$emit('on-charge-user-change', { userId: userId.join(','), bindIdList: [this.currentIncharge.id], userType })
            } else {
                this.$emit('on-charge-user-change', { userId, bindIdList: [this.currentIncharge.id], userType })
            }
            this.inChargeVisible = false
        },
        isAccepted(status) {
            return status === '4'
        },
        isUploaded(status) {
            return status === '2'
        },
        editInCharge(row, isClientInCharge) {
            this.selectAllUser()
            this.isClientInCharge = isClientInCharge
            this.currentIncharge = row
            if (this.isClientInCharge) {
                this.clientInchargeListIds = row.clientInchargeList && row.clientInchargeList.length && row.clientInchargeList.map(item => item.userId)
            }
            this.inChargeVisible = true
        },
        nextClick() {
            this.$emit('nextClick')
        },
        openEntity() {
            this.$emit('openEntity')
        }
    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser',
            getEntityIdsSelectAllTag: 'getEntityIdsSelectAllTag',
        }),
        splitData() {
            let fillLength = this.limitNum + 2 - (this.data.length - this.startIndex * this.limitNum)
            this.data.forEach(item => {
                if(item.childPbcGroup && item.childPbcGroup.length) {
                    item.childPbcGroup.forEach(childrenItem => {
                        if (childrenItem.clientInchargeList && childrenItem.clientInchargeList.length) {
                            childrenItem.clientUserName = childrenItem.clientInchargeList.map(e => e.userName).join(',')
                        }
                    })
                } else {
                    if (item.clientInchargeList && item.clientInchargeList.length) {
                        item.clientUserName = item.clientInchargeList.map(e => e.userName).join(',')
                    }
                }
            })
            if (this.data.length > this.limitNum && fillLength > 0) {
                return this.data.slice(this.startIndex * this.limitNum - fillLength, this.data.length)
            } else {
                return this.data.slice(this.startIndex * this.limitNum, (this.startIndex + 1) * this.limitNum + 2)
            }
        },
        emptyChosen() {
            return _.isEmpty(this.chosenList)
        },
        checkedAll() {
            if (this.chosenListIds.length > 0) {
                return this.tableInnerIds.every((id) => {
                    return this.chosenListIds.includes(id)
                })
            }
            return false
        },
        tableInnerIds() {
            let ids = []
            if (Array.isArray(this.data)) {
                for (let i = 0; i < this.data.length; i++) {
                    const element = this.data[i]
                    if (element && element.childPbcGroup) {
                        element.childPbcGroup.forEach((item) => {
                            const disabled = this.tableStatus.mode === 'setStatus' && item.status !== '2' && item.status !== '3'
                            if (!disabled) ids.push(item.id)
                            // if (this.tableStatus.mode !== 'setStatus' && item.status !==)
                        })
                    }
                    if (element.status !== '-1') {
                        const disabled = this.tableStatus.mode === 'setStatus' && element.status !== '2' && element.status !== '3'
                        if (!disabled) ids.push(element.id)
                    }
                }
            }
            return ids
        },
        chosenListIds() {
            return this.chosenList.map((item) => item.id)
        },
        sourceTypesMap() {
            const result = {}
            this.sourceTypes.forEach((sourceType) => {
                result[sourceType.value] = sourceType.internationalStatus
            })
            return result
        },
        applyFlagsMap() {
            const result = {}
            this.applyFlagsForView.forEach((applyFlag) => {
                result[applyFlag.internationalStatus] = applyFlag.label
            })
            return result
        },
        isClientUser() {
            return this.getUser.userType === '2'
        },
        clientOwnerDropdownList() {
            return this.clientOwnerList.filter(
                (v) =>
                    v.userName.toLowerCase().indexOf(this.clientOwnerDropdownFilterInput.toLowerCase()) !== -1 ||
                    v.email.toLowerCase().indexOf(this.clientOwnerDropdownFilterInput.toLowerCase()) !== -1
            )
        },
        kpmgOwnerDropdownList() {
            return this.kpmgOwnerList.filter(
                (v) =>
                    v.userName.toLowerCase().indexOf(this.kpmgOwnerDropdownFilterInput.toLowerCase()) !== -1 ||
                    v.email.toLowerCase().indexOf(this.kpmgOwnerDropdownFilterInput.toLowerCase()) !== -1
            )
        },
        serialNoColumnWidth() {
            return this.$i18n.locale == 'zh' ? '100' : '170'
        },
        clientUserHereTags() {
            return this.clientOwnerDropdownList.filter(item => this.clientUserHere.includes(item.userId))
        },
        applyFlagsForView() {
            return this.applyFlags.filter(filterItem => ["0", "1"].includes(filterItem.internationalStatus)).map(item => {
                                    return {
                                        ...item,
                                        label: this.$t(item.value)
                                    }
                                })
                                || []
        }
    },
    watch: {
        clientResponsibleHere(v) {
            this.filterChange = true
            this.$emit('update:clientResponsible', v)
        },
        kpmgResponsibleHere(v) {
            this.filterChange = true
            this.$emit('update:kpmgResponsible', v)
        },
        fileNameHere(v) {
            this.filterChange = true
            this.$emit('update:fileName', v)
        },
        periodEndDateHere(v) {
            this.filterChange = true
            this.$emit('update:periodEndDate', v)
        },
        commentDateHere(v) {
            this.filterChange = true
            this.$emit('update:commentDate', v)
        },
        uploadTimeHere(v) {
            this.filterChange = true
            this.$emit('update:uploadTime', v)
        },
        dayOverDueHere: {
            deep: true,
            handler(v) {
                this.filterChange = true
                this.$emit('update:dayOverDue', v)
            }
        },
        daysUntilDueHere: {
            deep: true,
            handler(v) {
                this.filterChange = true
                this.$emit('update:daysUntilDue', v)
            }
        },
        statusHere(v) {
            this.filterChange = true
            this.$emit('update:status', v)
        },
        status(v) {
            this.statusHere = v
        },
        sourceOfInfoHere(v) {
            this.filterChange = true
            this.$emit('update:sourceOfInfo', v)
        },
        applyFlagHere(v) {
            this.filterChange = true
            this.$emit('update:applyFlagInfo', v)
        },
        dueTimeHere(v) {
            this.filterChange = true
            this.$emit('update:dueTime', v)
        },
        createDateHere(v) {
            this.filterChange = true
            this.$emit('update:createDate', v)
        },
        topicDesHere(v) {
            this.filterChange = true
            this.$emit('update:topicDes', v)
        },
        topicHere(v) {
            this.filterChange = true
            this.$emit('update:topic', v)
        },
        serialNoHere(v) {
            this.filterChange = true
            this.$emit('update:serialNo', v)
        },
        entityId(v) {
            this.filterChange = true
            this.$emit('update:entityId', v)
        },
        tableStatus: {
            handler: function (val, oldval) {
                if (val.editable) {
                    // 重新打开 chosenList清空
                    this.chosenList = []
                }
            },
            deep: true,
            immediate: true
        },
        splitData: {
            handler: function (val, oldVal) {
                if (this.expand) {
                    val.forEach((i, n) => {
                        if (i.childPbcGroup && i.childPbcGroup.length > 0) {
                            this.$nextTick(() => {
                                this.$refs.finalTable.toggleRowExpansion(i, this.expand)
                            })
                        }
                    })
                }
            }
        },
        showColumns() {
            this.$nextTick(() => {
                let preDom = this.$refs.finalTable.bodyWrapper
                this.$refs.finalTable.doLayout()
                this.tableKey = `${Math.random()}`
                // 表格重构，重新添加滚动事件
                this.scrollEvent(preDom)
            })
        },
        lastedUploadUserAccount(v) {
            this.lastedUploadUserAccountHere = v
        },
        lastedUploadUserAccountHere(v) {
            this.filterChange = true
             
            this.$emit('update:lastedUploadUserAccount', v)
        },
        serialNo(v) {
            this.serialNoHere = v
        },
        entityId(v) {
            this.entityId = v
        },
        topic(v) {
            this.topicHere = v
        },
        topicDes(v) {
            this.topicDesHere = v
        },
        createDate(v) {
            this.createDateHere = v
        },
        dueTime(v) {
            this.dueTimeHere = v
        },
        sourceOfInfo(v) {
            this.sourceOfInfoHere = v
        },
        applyFlagInfo(v) {
            this.applyFlagHere = v
        },
        status(v) {
            this.statusHere = v
        },
        dayOverDue(v) {
            this.dayOverDueHere = v
        },
        daysUntilDue(v) {
            this.daysUntilDueHere = v
        },
        clientResponsible(v) {
            this.clientResponsibleHere = v
        },
        kpmgResponsible(v) {
            this.kpmgResponsibleHere = v
        },
        uploadTime(v) {
            this.uploadTimeHere = v
        },
        periodEndDate(v) {
            this.periodEndDateHere = v
        },
        commentDate(v) {
            this.commentDateHere = v
        },
        fileName(v) {
            this.fileNameHere = v
        },
        clientConfirmDate(v) {
            this.clientConfirmDateHere = v
        },
        clientConfirmDateHere(v) {
            this.$emit('update:clientConfirmDate', v)
        }
    },
    props: {
        sourceTypes: {
            type: Array,
            default: () => []
        },
        applyFlags: {
            type: Array,
            default: () => []
        },
        data: {
            type: Array,
            default: () => []
        },
        tableStatus: {
            type: Object,
            required: true
        },
        onCancel: {
            type: Function,
            default: () => {}
        },
        statusList: {
            type: Array,
            default: () => []
        },
        topicList: {
            type: Array,
            required: true,
            default: () => []
        },
        onChange: {
            type: Function,
            required: true
        },
        onChangeRow: {
            type: Function,
            required: true
        },
        onChangeStatusPopShow: {
            type: Function
        },
        onDownLoad: {
            type: Function
        },
        onUploadFileAfter: {
            type: Function
        },
        downloading: {
            type: Boolean,
            default: false
        },
        kpmgOwnerList: {
            type: Array,
            required: true,
            default: () => []
        },
        clientOwnerList: {
            type: Array,
            required: true,
            default: () => []
        },
        loading: Boolean,
        pagination: Object,
        onPaginationChange: Function,
        downloadAble: Boolean,
        curUserName: String,
        siteId: String,
        showColumns: Array,
        serialNo: String,
        entityIds: Array,
        topicDesList: Array,
        topicDes: Array,
        createDate: Array,
        dueTime: Array,
        sourceOfInfo: Array,
        applyFlagInfo: Array,
        filterStatusList: Array,
        status: Array,
        uploadTime: Array,
        periodEndDate: Array,
        commentDate: Array,
        fileName: String,
        clientResponsible: Array,
        kpmgResponsible: Array,
        updateGuide: Boolean,
        updateGuideStep: Number,
        screenWidth: Number,
        lastedUploadUserAccount: Array,
        topic: Array,
        messageType: String,
        dayOverDue: {
            type: Array,
            default: () => ['', '']
        },
        daysUntilDue: {
            type: Array,
            default: () => ['', '']
        },
        clientConfirmDate: {
            type: Array,
            default: () => ['', '']
        },
    },
    components: {
        CellItem,
        Upload,
        FilelistTable,
        messageBoard,
        MultiSelectPopver,
        TopicMultiSelectPopver,
        DatePickerPopover,
        GuidanceTooltip
    }
}
</script>

<style scoped>
.detail-header {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.title {
    margin-right: 10px;
}
.not-application-cls {
    color:#fd349c;
    cursor: pointer;
}
::v-deep .el-table .client-row-cls td {
    background: #d3cfc7 !important;
}

::v-deep .el-table .kpmg-row-cls td {
    background: #d3cfc7 !important;
}
::v-deep .el-table .row-cls {
    height: 50px;
}
.wl-container {
    height: 100%;
    position: relative;
}
.table-container-wrapper {
    height: calc(100% - 48px);
}
.table-container-wrapper.show-table-bottom-operate {
    height: calc(100% - 98px);
}
::v-deep .el-table th.el-table__cell>.cell {
    display: flex;
    flex-direction: row;
    justify-content: center;
}
::v-deep .el-table .cell.table-header-editable {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
}
::v-deep .el-table .cell.table-header-editable.not-allow {
    cursor: default;
}

.el-table .table-header-editable .el-dropdown-link {
    font-size: 12PX;
    color: rgb(68, 68, 68);
}
.wl-btn-container {
    height: 50px;
    padding: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.wl-icon-upload {
    font-size: 18px;
    color: #3879eb;
    cursor: pointer;
}
.wl-icon-not-upload {
    font-size: 18px;
    color: #c0c4cc;
    cursor: default;
}

.wl-icon-messageBoard {
    font-size: 18px;
    color: #3879eb;
    cursor: pointer;
}

.wl-icon-messageBoardNull {
    color: #c0c4cc;
    font-size: 18px;
    cursor: pointer;
}

.file-number-hint {
    display: block;
    margin-right: 10px;
    width: 100%;
    cursor: pointer;
    user-select: none;
    color: blue;
    text-decoration: underline;
}

.openAll {
    font-size: 14px;
    margin-right: 10px;
    cursor: pointer;
}

.openAll:hover {
    color: #409eff;
}

.descForTopic {
    position: absolute;
    right: 6px;
    top: 13px;
    font-size: 14px;
}

.descForTopic:hover,
.comments:hover {
    opacity: 0.8;
}

.comments {
    position: absolute;
    right: 0px;
    top: 0px;
    font-size: 14px;
    cursor: pointer;
    color: #44b027;
}

.wl-item {
    margin-right: 15px;
    width: 100%;
}

::v-deep .status_background_1 {
    color: #ecb113;
    position: relative;
}
::v-deep .status_background__1 {
    color: #ed2124;
    position: relative;
}
::v-deep .status_background_2 {
    color: #fd349c;
    position: relative;
}
::v-deep .status_background_3 {
    color: #1e49e2;
    position: relative;
}
::v-deep .status_background_4 {
    color: #269924;
    position: relative;
}

::v-deep .status_background_1:before {
    content: "\e7a3";
    font-family: element-icons !important;
    color: #ecb113;
    font-size: 14PX;
    position: absolute;
    top: 1px;
    left: 5px;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}
::v-deep .status_background__1:before {
    content: "\e7a3";
    font-family: element-icons !important;
    color: #ed2124;
    font-size: 14PX;
    position: absolute;
    top: 1px;
    left: 5px;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}
::v-deep .status_background_2:before {
    content: "\e7a3";
    font-family: element-icons !important;
    color: #fd349c;
    font-size: 14PX;
    position: absolute;
    top: 1px;
    left: 5px;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}
::v-deep .status_background_3:before {
    content: "\e71f";
    font-family: element-icons !important;
    color: #1e49e2;
    font-size: 14PX;
    position: absolute;
    top: 1px;
    left: 5px;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}
::v-deep .status_background_4:before {
    content: "\e79c";
    font-family: element-icons !important;
    color: #269924;
    font-size: 14PX;
    position: absolute;
    top: 1px;
    left: 5px;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}

::v-deep .status_background_1 .el-input__inner {
    padding-left: 20PX;
    color: #ecb113 !important;
}
::v-deep .status_background__1 .el-input__inner {
    padding-left: 20PX;
    color: #ed2124 !important;
}
::v-deep .status_background_2 .el-input__inner {
    padding-left: 20PX;
    color: #fd349c !important;
}

::v-deep .status_background_3 .el-input__inner {
    padding-left: 20PX;
    color: #1e49e2 !important;
}
::v-deep .status_background_4 .el-input__inner {
    padding-left: 20PX;
    color: #269924 !important;
}

.el-date-editor.el-input.wl-date-item {
    width: 100%;
}
.dotting {
    display: inline-block;
    width: 10px;
    min-height: 2px;
    padding-right: 2px;
    border-left: 2px solid currentColor;
    border-right: 2px solid currentColor;
    background-color: currentColor;
    background-clip: content-box;
    box-sizing: border-box;
    animation: dot 4s infinite step-start both;
}
.dotting:before {
    content: '...';
} /* IE8 */
.dotting::before {
    content: '';
}
:root .dotting {
    margin-left: 2px;
    padding-left: 2px;
} /* IE9+ */

@keyframes dot {
    25% {
        border-color: transparent;
        background-color: transparent;
    } /* 0个点 */
    50% {
        border-right-color: transparent;
        background-color: transparent;
    } /* 1个点 */
    75% {
        border-right-color: transparent;
    } /* 2个点 */
}
.el-icon-loading.downloading-placeholder {
    cursor: not-allowed;
    margin-left: 20px;
    margin-right: 10px;
    font-size: 200%;
    font-weight: 600;
}
::v-deep .el-pagination .el-select .el-input {
    width: 150px;
}
.item-edit-cls {
    font-size: 15px;
    cursor: pointer;
    color: #3879eb;
    float: right;
}
::v-deep .el-table__body-wrapper {
    overflow-y: scroll;
}
.table-header-edit-cls {
    color: #3879eb;
}
.el-dropdown-menu {
    /* min-height: 50vh; */
    max-height: 90vh;
    overflow-y: scroll;
}
.updateGuideTitle {
    position: absolute;
    background-color: white;
    height: 30PX;
    width: calc(100% - 50PX - 200PX - 70PX - 85PX - 150PX);
    z-index: 101;
    border: 2PX solid #3879eb !important;
    border-radius: 10px;
    left: 250PX;
}
::v-deep .el-table__fixed-header-wrapper {
    z-index: auto;
}
.margin-bottom-10 {
    margin-bottom: 10PX;
}
.guide-btn {
    float: right;
    color: #3879eb;
}
</style>
<style>
.el-dropdown-link,
.el-dropdown-selfdefine {
    font-size: 12PX;
    color: #444444;
}
.header-with-popup {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 12PX;
    position: inherit;
}
.th-filter-down {
    margin-left: 5px;
    cursor: pointer;
}
.th-header-edit {
    cursor: pointer;
}
.updateGuideTitle .updateGuideTip {
    z-index: 101;
    background-color: #3879eb;
    padding: 20px;
    color: white;
    position: absolute;
    left: 0;
    top: 40PX;
    width: 240PX;
    border-radius: 10px;
    text-align: left;
    font-size: 14PX;
    line-height: normal;
}
.updateGuideHeaderTitle .cell{
    z-index: 101;
}
.client-multiselect {
    display: flex;
    flex-direction: column;
    max-width: 100vw;
    max-height: 50vh;
    overflow-x: hidden;
    overflow-y: scroll;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.client-multiselect::-webkit-scrollbar { width: 0!important }
.client-multiselect { -ms-overflow-style: none; }
.client-multiselect { overflow: -moz-scrollbars-none; }
.client-multiselect .group-check-checkbox {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

}
.client-multiselect .group-check-checkbox {
    width: 100%;
}
.client-multiselect .group-check-checkbox .el-checkbox {
    width: 100%;
    margin-bottom: 12px;
}
.client-multiselect .group-check-checkbox .checkbox-text {
    margin-left: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 20px;
}
.client-multiselect .group-check-checkbox .checkbox-text .input-row {
    margin-left: 20px;
    margin-top: 5px;
}
.client-multiselect .group-check-checkbox .checkbox-text .input-row .ri {
    margin: 0 10px;
}
.client-multiselect .group-check-checkbox .checkbox-text .input-row .input-row-input {
    width: 100px;
}
.client-multiselect .group-check-checkbox .text {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.client-multiselect .select-btn-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin: 10px 0;
}
.client-multiselect .select-btn-row .select-btn {
    color: #409eff;
    margin-left: 10px;
    cursor: pointer;
}
.client-multiselect .select-tag {
    margin: 0 6px 6px 0;
}
.el-table__empty-block {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center; /* 确保文本居中 */
}
</style>
